import { SxProps, Theme } from '@mui/material';

export const styles: Record<'label', SxProps<Theme>> = {
  label: {
    alignItems: 'center',
    display: 'flex',
    height: 48,
  },
};
